import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs'

@Injectable()
export class AuthHttpService {

    constructor(private http: HttpClient) { }
    public get<T>(url: string, options?: IHttpOptions): Observable<T> {
        return this.http.get<T>(url, this.setAuth(options))
    }

    public post<T>(url: string, body: any, options?: IHttpOptions): Observable<T> {
        return this.http.post<T>(url, body, this.setAuth(options))
    }

    public put<T>(url: string, body: any, options?: IHttpOptions): Observable<T> {
        return this.http.put<T>(url, body, this.setAuth(options))
    }

    public delete<T>(url: string, options?: IHttpOptions): Observable<T> {
        return this.http.delete<T>(url, this.setAuth(options))
    }

    public patch<T>(url: string, body: any, options?: IHttpOptions): Observable<T> {
        return this.http.patch<T>(url, body, this.setAuth(options))
    }

    public head<T>(url: string, options?: IHttpOptions): Observable<T> {
        return this.http.head<T>(url, this.setAuth(options))
    }

    public options<T>(url: string, options?: IHttpOptions): Observable<T> {
        return this.http.options<T>(url, this.setAuth(options))
    }

    public ensureAuthTokenPresent() {
        return this.setAuth()
    }

    private setAuth(options?: IHttpOptions): object {
        let token = localStorage.getItem('sbw_Token')
        if (!token) {
            throw new Error('No token for auth')
        }
        let headers = { ...(options && options.headers || {}), 'Authorization': `Bearer ${token}` }
        return { ...options, headers }
    }
}

export interface IHttpOptions {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    params?: HttpParams | {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
}
